import axios from 'axios';
import apiConfig from '../shared/config/api.config';

export default function restartCheckinStatRequest(checkinGuestId) {
  const {
    host,
    URIs: { restartCheckinStat },
  } = apiConfig;

  const uri = `${host}${restartCheckinStat}`;

  return axios
    .post(uri, {
      idCheckinGuest: checkinGuestId,
    })
    .then(res => {
      return res.data;
    });
}
